import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { apiRequest } from '../../api/client';
import { useAuth } from '../../auth/AuthContext';
import { roomColour, roomGlyph } from '../Together/roomAppearance';
import './Join.css';

// Where a room's QR code lands: see what you're joining, then join (signing in first if needed).
const Join = () => {
  const { code = '' } = useParams();
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [invite, setInvite] = useState<any>(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => { apiRequest<any>(`/invites/${encodeURIComponent(code)}`).then(setInvite).catch(e => setError(e.message || 'This room code is invalid or has expired.')); }, [code]);
  const join = async () => {
    setBusy(true); setError('');
    try { const room = await apiRequest<any>('/sessions/join', { method: 'POST', body: JSON.stringify({ code }) }); navigate(`/together?room=${room.sessionId}`, { replace: true }); }
    catch (e: any) { setError(e.message); setBusy(false); }
  };
  const next = encodeURIComponent(`/join/${code}`);

  return <main className="join">
    <section className="join__card">
      {invite ? <>
        <span className="join__icon" style={{ background: roomColour(invite.roomTheme) }} aria-hidden="true">{roomGlyph(invite.roomIcon)}</span>
        <p className="join__eyebrow">{invite.hostFirstName ? `${invite.hostFirstName.toUpperCase()} INVITED YOU` : 'YOU’RE INVITED'}</p>
        <h1>{invite.roomName}</h1>
        <p className="join__meta">{invite.memberCount} {invite.memberCount === 1 ? 'person' : 'people'} in the room{invite.full ? ' · full' : ''}</p>
        <p className="join__copy">Join the room, answer a few private questions, and pick a film together from one shared shortlist.</p>
        {loading ? null : user
          ? <button className="join__cta" onClick={join} disabled={busy || invite.full}>{busy ? 'Joining…' : invite.full ? 'This room is full' : 'Join the room →'}</button>
          : <div className="join__auth"><Link className="join__cta" to={`/account?mode=signup&next=${next}`}>Create a free account to join</Link><Link className="join__secondary" to={`/account?next=${next}`}>I already have an account</Link></div>}
        <a className="join__app" href={`findafilm://join/${code}`}>Have the app? Open in Find A Film →</a>
      </> : <>
        <h1>{error ? 'That code didn’t work' : 'Finding your room…'}</h1>
        {error && <><p className="join__copy">{error} Ask whoever invited you to show the QR code again.</p><Link className="join__cta" to="/together">Go to Rooms</Link></>}
      </>}
      {invite && error && <p className="join__error" role="alert">{error}</p>}
    </section>
  </main>;
};

export default Join;
